import request from '@/utils/request'

// 列表
export function policyList(data) {
    return request({
      url: 'admin/data/policy/list',
      method: 'post',
      data
    })
  }

// 详情
export function info(informId) {
    return request({
        url: `admin/data/policy/info/${informId}`,
        method: 'get'
    })
}